/* eslint-disable react/display-name */
import {
  documentToReactComponents,
  Options,
} from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';

const options: Options = {
  renderNode: {
    [BLOCKS.QUOTE]: (_, children) => (
      <blockquote className="text-r-2xl font-bold">{children}</blockquote>
    ),
    [BLOCKS.LIST_ITEM]: (node) => {
      // https://github.com/contentful/rich-text/issues/126
      // @ts-ignore
      const childrenWithoutP = documentToReactComponents(node, {
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children) => children,
          [BLOCKS.LIST_ITEM]: (_, children) => children,
        },
      });

      return <li>{childrenWithoutP}</li>;
    },
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      if (node.data.target?.fields?.file?.contentType.startsWith('video')) {
        return (
          <video controls className="mx-auto rounded-lg bg-gray-100">
            <source
              src={`https://${node.data.target?.fields?.file?.url}`}
              type={node.data.target?.fields?.file?.contentType}
            />
          </video>
        );
      }

      return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={`https://${node.data.target?.fields?.file?.url}`}
          alt={node.data.target?.fields?.title}
          className="mx-auto rounded-lg bg-gray-100"
        />
      );
    },
  },
};

type Props = {
  document: any;
  className?: string;
};

export default function RichTextRenderer({ document, className }: Props) {
  return (
    <div className={`prose max-w-none break-words rich-text ${className}`}>
      {documentToReactComponents(document, options)}
    </div>
  );
}
